import { useEffect, useState } from 'react'
import useFilterStore from 'stores/useFilterStore'
import { EmployeeFilterName } from 'types/jobs'
import type { Filter } from 'types/table'
import type { UseFilter } from 'types/table'
import useFilterEmployeeStore from './useFilterEmployeeStore'

export default function useFilterEmployee() {
  const { filters, onAddFilter, onCleanFilters } = useFilterEmployeeStore()
  const { onCloseAnchor } = useFilterStore()

  const [filterEmployee, setFilteremployee] = useState({
    company_name: '',
    status: [] as Array<UseFilter>,
    role: [] as Array<UseFilter>
  })

  useEffect(() => {
    const filterEntries = Object.entries(filters)
      .map(([key, value]) => {
        return {
          key: Array.isArray(value) && value.length > 0 ? key : null,
          value: JSON.parse(JSON.stringify(value)) as Array<string>
        }
      })
      .filter(item => item.key)

    filterEntries.map(item => {
      setFilteremployee(prevState => {
        return {
          ...prevState,
          [item.key as EmployeeFilterName]: item.value.map(item => {
            return {
              id: item,
              label: item,
              checked: true
            }
          })
        }
      })
    })
    onChangeSingleValue(filters.company_name)
  }, [])

  const onClearFilters = (name: EmployeeFilterName) => {
    onCleanFilters(name)
    onCloseAnchor()
  }

  const onAddUrlFilters = (name: EmployeeFilterName) => {
    onAddFilter(filterEmployee[name], name)
    onCloseAnchor()
  }

  const onChangeValue = ({
    filter,
    name
  }: {
    filter: Filter
    name: 'status' | 'role'
  }) => {
    setFilteremployee(prevState => {
      if (!filter.checked) {
        return {
          ...prevState,
          [name]: [...prevState[name].filter(item => item.id !== filter.id)]
        }
      }
      return {
        ...prevState,
        [name]: [
          ...prevState[name].filter(item => item.id !== filter.id),
          filter
        ]
      }
    })
  }

  const onChangeSingleValue = (value: string) => {
    setFilteremployee(prevState => ({
      ...prevState,
      company_name: value
    }))
  }

  return {
    onChangeSingleValue,
    onChangeValue,
    onClearFilters,
    onAddUrlFilters,
    filterEmployee
  }
}
